// TODO
Jelly.Media =
{
	Players: {},	
	Global_Audio_Player_Controller: null,
	Global_Audio_Player_Element: null,
	Global_Audio_Player_Wrapper: null,
	Global_Audio_Source: null,
	Global_Audio_URL_Callbacks: {},
	Global_Audio_Player_Playing: false,
}